import React, { useMemo, useState } from 'react'
import { useExhibitorDataState } from '../../globalStates/ExhibitorDataState';
import { useLanguageState } from '../../globalStates/LanguageState';
import { useConfigDataState } from '../../globalStates/ConfigDataState';
import { ReferenceDataType, withReferenceDataState } from '../../globalStates/ReferenceDataHOC';
import Page from '../../components/Page';
import CategoriesContents from './CategoriesContents';
import Counter from '../../components/Page/Counter';

interface CategoriesPageProps {
}

const CategoriesPage: React.FC<CategoriesPageProps & ReferenceDataType> = ({ refDataState }) => {
    const branding = useLanguageState().getStrings()
    const selectedCategoriesStates = useExhibitorDataState().getCategories()

    const showCounter = branding.configuration.categoriesPage.showCounter
    const [count, setCount] = useState<number>(0)

    const refCategories = useMemo(() => refDataState.getCategories("ORGANIZATION", branding.configuration.categoriesPage.categoryWhitelist), [branding.configuration.categoriesPage.categoryWhitelist, refDataState])
    const serviceKeys = useConfigDataState().getServiceKeys()

    return (
        <Page
            title={branding.configuration.categoriesPage.pageTitle}
            sideTitle={showCounter ? <Counter count={String(count)} limit={String(serviceKeys.category)} showCounter /> : null}
            description={branding.configuration.categoriesPage.pageDescription}
        >
            <CategoriesContents selectedCategoriesStates={selectedCategoriesStates} refCategories={refCategories} limit={serviceKeys.category} countableCategories={branding.configuration.countableCategories.categoriesCountableCategories} setCount={setCount} />
        </Page>
    );
}

export default React.memo(withReferenceDataState(CategoriesPage))
